import { createFileRoute } from "@tanstack/react-router";
import Page, { faqItems } from "@/pages/GuiaAlimentacaoBrasileirosAustralia";
import { pageHead, faqJsonLd, breadcrumbJsonLd } from "@/lib/seo";

export const Route = createFileRoute("/guia-alimentacao-brasileiros-australia")({
  head: () =>
    pageHead({
      title: "Alimentação na Austrália: guia prático para brasileiros | Clara Camille",
      description:
        "Mora na Austrália e sente falta da comida do Brasil? Veja substituições, o que comprar no Coles, Woolies e Aldi e refeições práticas para a rotina daqui.",
      path: "/guia-alimentacao-brasileiros-australia",
      jsonLd: [
        faqJsonLd(faqItems),
        breadcrumbJsonLd([
          {
            name: "Guia de alimentação para brasileiros na Austrália",
            path: "/guia-alimentacao-brasileiros-australia",
          },
        ]),
      ],
    }),
  component: Page,
});
